// Plain CommonJS so `next-sitemap.config.js` can require it too, and the app can
// import it through webpack: the EN <-> FR route map and the hreflang triple
// derived from it must have exactly one definition.
const TRANSLATED_ROUTES = require('./routes.json');

/**
 * hreflang alternates for an EN path, or `undefined` when the page has no FR twin.
 * @arg {string} enPath EN path, as declared in `routes.json`.
 * @return {Array<{hrefLang: string, path: string}>|undefined}
 */
const alternatesFor = (enPath) => {
  const frPath = TRANSLATED_ROUTES[enPath];
  return frPath
    ? [
        { hrefLang: 'en', path: enPath },
        { hrefLang: 'fr', path: frPath },
        { hrefLang: 'x-default', path: enPath },
      ]
    : undefined;
};

module.exports = { TRANSLATED_ROUTES, alternatesFor };
